import React from 'react';
import PropTypes from 'prop-types';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import convertToFormErrors from 'utils/convertToFormErrors';
import api from 'api';
import { withRouter, Link } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import SubmitButton from 'form/SubmitButton';
import Component from 'BaseComponent';
import { withState } from 'recompose';

@withRouter

@withState('otpStatus', 'setOtpStatus', {
  required: false,
})

@reduxForm({
  form: 'Login',
  validate: generateFormValidation({
    email: [validators.required(), validators.email()],
    password: [validators.required(), validators.minLength(4)],
    otp_code: [validators.required(), validators.minLength(6)],
  }),
  onSubmit(values, dispatch, props) {
    return dispatch(api.createSession({
      data: {
        type: 'session',
        attributes: values,
      },
    }))
    .then(() => {
      dispatch(notice('Login.success'));
      props.history.push('/');
    })
    .catch((e) => {
      if (
        e.body &&
        e.body.errors &&
        e.body.errors[0] &&
        e.body.errors[0].code === 'REQUIRE_OTP_CODE'
      ) {
        props.setOtpStatus({ required: true });
        return null;
      } else if (
        e.body &&
        e.body.errors &&
        e.body.errors[0] &&
        e.body.errors[0].code === 'INVALID_FIELD'
      ) {
        return Promise.reject(convertToFormErrors(e));
      }
      dispatch(alert('Login.invalidCredentials'));
      return Promise.reject(convertToFormErrors(e));
    });
  },
})

export default class Login extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
    otpStatus: PropTypes.object,
  }

  render() {
    const { handleSubmit, submitting, error, dirty, otpStatus } = this.props;


    return (
      <div className="island">
        <div className="island__wrap">
          <a href="https://www.hardypress.com">
            <div className="island__title" />
          </a>
          <div className="island__content">
            <div className="island__content__title">
              Log in
            </div>
            <Form error={error} onSubmit={handleSubmit}>
              { otpStatus.required ? (
                <Field label="Login.otpCode" name="otpCode" placeholder="****">
                  <input type="otpCode" className="form__input--large" />
                </Field>
              ) : (
                <div>
                  <Field label="Login.email" name="email" placeholder="your.email@gmail.com" >
                    <input type="text" className="form__input--large" />
                  </Field>
                  <Field label="Login.password" name="password" placeholder="****">
                    <input type="password" className="form__input--large" />
                  </Field>
                </div>
              )}
              <div className="Form__actions Form__actions--center">
                <SubmitButton
                  dirty={dirty}
                  className="button button--primary button--expand button--huge"
                  submitting={submitting}
                  label="Login.submit"
                />
              </div>
              <p className="space--top-2 align--center">
                <Link to="/request_password_reset">
                  {this.t('Login.resetPassword')}
                </Link>
              </p>
            </Form>
          </div>
          <div className="island__footer">
            {this.t('Login.haveAccount')}
            &nbsp;
            <Link to="/register">
              {this.t('Login.register')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Login.jsx